import { render } from "./CalendarEventSaveView.vue?vue&type=template&id=faaad606&scoped=true"
import script from "./CalendarEventSaveView.vue?vue&type=script&lang=ts"
export * from "./CalendarEventSaveView.vue?vue&type=script&lang=ts"

import "./CalendarEventSaveView.vue?vue&type=style&index=0&id=faaad606&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-faaad606"

export default script